import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const FactBreakingList = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/breaking/facts").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const clear = async (f) => { try { await api.post(`/admin/facts/${f.id}/breaking/clear`); toast.success("No longer showing as BREAKING"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <section className="surface space-y-3 p-5" data-testid="admin-fact-breaking">
      <h2 className="flex items-center gap-2 text-2xl"><Radio size={18} className="text-rose-600" />Breaking stories in your Feed</h2>
      <p className="text-xs text-slate-500">Published Facts the AI marked as breaking. They go straight to your Feed for the area shown, for 24 hours. Pull one down if it isn't breaking.</p>
      {rows === null ? <p className="text-sm text-slate-500">Loading…</p> : !rows.length ? <p className="text-sm text-slate-500" data-testid="admin-fact-breaking-empty">No breaking stories right now.</p> : rows.map((f) => (
        <div key={f.id} className="flex flex-wrap items-start justify-between gap-3 rounded-xl border border-rose-200 bg-rose-50 p-3" data-testid={`admin-fact-breaking-${f.id}`}>
          <div className="min-w-0">
            <Link to={`/facts/${f.id}`} className="text-sm font-medium hover:underline">{f.headline}</Link>
            <p className="text-xs text-slate-600">{f.source_name} · {f.breaking.area.scope === "global" ? "Global" : f.breaking.area.city || f.breaking.area.region_code || f.breaking.area.country_code} · until {new Date(f.breaking.expires_at).toLocaleString()}</p>
            {f.breaking.reason && <p className="text-xs text-slate-500">AI: {f.breaking.reason}</p>}
          </div>
          <Button size="sm" variant="outline" className="rounded-full bg-white" onClick={() => clear(f)} data-testid={`admin-fact-breaking-clear-${f.id}`}>Stop showing</Button>
        </div>
      ))}
    </section>
  );
};
